export default "__VITE_ASSET__CtNBoHve__"